module.exports = __webpack_public_path__ + "static/media/asparagus_porkchop.cdaac52c.png";